/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { switch_source_id } from '../models/switch_source_id';
import type { SwitchesSourcesConnectionsListRequest } from '../models/SwitchesSourcesConnectionsListRequest';
import type { SwitchesSourcesConnectionsListResponse } from '../models/SwitchesSourcesConnectionsListResponse';
import type { SwitchesSourcesConnectRequest } from '../models/SwitchesSourcesConnectRequest';
import type { SwitchesSourcesConnectResponse } from '../models/SwitchesSourcesConnectResponse';
import type { SwitchesSourcesIsConnectedResponse } from '../models/SwitchesSourcesIsConnectedResponse';
import type { SwitchesSourcesListRequest } from '../models/SwitchesSourcesListRequest';
import type { SwitchesSourcesListResponse } from '../models/SwitchesSourcesListResponse';
import type { SwitchesSourcesPostRequest } from '../models/SwitchesSourcesPostRequest';
import type { SwitchesSourcesPostResponse } from '../models/SwitchesSourcesPostResponse';
import type { SwitchesSourcesPutRequest } from '../models/SwitchesSourcesPutRequest';
import type { SwithesSourcesGetResponse } from '../models/SwithesSourcesGetResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SwitchesSourcesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a Switch Source linked to a contract
     * Create a Switch Source linked to a contract. It links the source to all the destinations of the contract. (Access: admin)
     * @returns SwitchesSourcesPostResponse Created SwitchSource
     * @returns any Unexpected error
     * @throws ApiError
     */
    public createSource({
        requestBody,
    }: {
        requestBody: SwitchesSourcesPostRequest,
    }): CancelablePromise<SwitchesSourcesPostResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/sources',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a Switch Source
     * Returns a SwitchDsource based on a single ID (Access: admin)
     * @returns SwithesSourcesGetResponse Switch Source's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSwitchSourceById({
        id,
    }: {
        /**
         * ID of the Switch Source to fetch
         */
        id: switch_source_id,
    }): CancelablePromise<SwithesSourcesGetResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/switches/sources/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a Switch Source
     * Update a Switch Source. (Access: admin)
     * @returns SwitchesSourcesPostResponse Switch Source updated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateSwitchSource({
        id,
        requestBody,
    }: {
        /**
         * ID of the Switch Source to update
         */
        id: switch_source_id,
        /**
         * Switch Source's information
         */
        requestBody: SwitchesSourcesPutRequest,
    }): CancelablePromise<SwitchesSourcesPostResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/switches/sources/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a Switch Source
     * Deletes a Switch Source linked to contract. All the associated connections are destroyed.  (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteSwitchSourceById({
        id,
    }: {
        /**
         * ID of the switch source to delete
         */
        id: switch_source_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/switches/sources/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * List Switch Sources associated to a contract
     * List Switch sources associated to a contract (Access: all)
     * @returns SwitchesSourcesListResponse Switch source list response
     * @returns any Unexpected error
     * @throws ApiError
     */
    public listSwitchSources({
        requestBody,
    }: {
        /**
         * Switch source list request
         */
        requestBody: SwitchesSourcesListRequest,
    }): CancelablePromise<SwitchesSourcesListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/sources/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Connect an application through its source to a switch
     * Called by an application that starts and needs to know which gateway's ports to use. It puts the gateway in used state (Access: all)
     * @returns SwitchesSourcesConnectResponse Switch source connection response
     * @returns any Unexpected error
     * @throws ApiError
     */
    public connectToSwitchSource({
        requestBody,
    }: {
        /**
         * Switch source connection request
         */
        requestBody: SwitchesSourcesConnectRequest,
    }): CancelablePromise<SwitchesSourcesConnectResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/sources/connect',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get the connected state of a Switch Source
     * Returns the connected state of a SwitchSource based on a single ID (Access: admin)
     * @returns SwitchesSourcesIsConnectedResponse Switch Source's connected state
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSwitchSourceConnectedStateById({
        id,
    }: {
        /**
         * ID of the Switch Source
         */
        id: switch_source_id,
    }): CancelablePromise<SwitchesSourcesIsConnectedResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/switches/sources/{id}/isconnected',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Force the connected state of a Switch Source
     * Force the connected state of a Switch Source (Access: admin)
     * @returns any Switch Source is now connected
     * @throws ApiError
     */
    public postSwitchSourceForceConnectionById({
        id,
    }: {
        /**
         * ID of the Switch Source
         */
        id: switch_source_id,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/sources/{id}/forceconnection',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a list of Switch Sources and connections linked to a contract
     * Get a list of Switch Sources and connections linked to a contract. (Access: all)
     * @returns SwitchesSourcesConnectionsListResponse Switches list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getSourcesConnectionsList({
        requestBody,
    }: {
        requestBody: SwitchesSourcesConnectionsListRequest,
    }): CancelablePromise<SwitchesSourcesConnectionsListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/switches/sources/connections/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
